import SectionHeader from './SectionHeader';

const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '飞飞漫画网对图片进行极速加载优化，打开即读、无需漫长等待，翻页流畅不卡顿。',
    accent: 'bg-primary-500',
  },
  {
    icon: 'ri-swap-3-line',
    title: '翻页流畅',
    desc: '智能预加载下一页，翻页丝滑跟手，随时随地畅快看漫画，追更体验直接拉满。',
    accent: 'bg-accent-500',
  },
  {
    icon: 'ri-moon-clear-line',
    title: '夜间模式',
    desc: '一键切换低蓝光护眼夜间模式，深色画面、柔和对比度，夜间阅读更舒适。',
    accent: 'bg-secondary-500',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="relative overflow-hidden bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          align="center"
          eyebrow="阅读体验"
          title="把阅读体验做到极致"
          desc="飞飞漫画网从加载、翻页到护眼，每一个细节都为漫画爱好者量身打磨。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {features.map((f) => (
            <article
              key={f.title}
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1 md:p-7"
            >
              <span className={`flex h-14 w-14 items-center justify-center rounded-lg text-background-50 ${f.accent}`}>
                <i className={`${f.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading mt-5 text-xl text-foreground-950 md:text-2xl">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
              <span className="pointer-events-none absolute -right-4 -top-4 h-20 w-20 rounded-full bg-background-100 transition-transform duration-300 group-hover:scale-150" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}